import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS,
  ACTION_TEMPLATE_CONFIG_SET_FILE__SUCCESS,

  ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS,
  ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL,
  ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST,
} from '../actionTypes';

import errors from './errors';


const data = (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_TEMPLATE_CONFIG_PREPARATION__SUCCESS:
    case ACTION_TEMPLATE_CONFIG_SET_FILE__SUCCESS:
    case ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS: {
      const { dataScheme, dataSchemeGroups } = action.payload.templateConfigPreparation;

      return { dataScheme, dataSchemeGroups };
    }

    default:
      return state;
  }
};

const isFileBeingReseted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TEMPLATE_CONFIG_RESET_FILE__REQUEST:
      return { ...state, ...{ [action.payload.itemName]: true } };

    case ACTION_TEMPLATE_CONFIG_RESET_FILE__SUCCESS:
    case ACTION_TEMPLATE_CONFIG_RESET_FILE__FAIL:
      return { ...state, ...{ [action.payload.itemName]: false } };

    default:
      return state;
  }
};

export default combineReducers({
  data,
  isFileBeingReseted,
  errors,
});
